@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(569_226_620)
public val Res.string.payroll_fact_student: StringResource by lazy {
      StringResource("string:payroll_fact_student", "payroll_fact_student", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209129, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296661, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190880, 52),
      ))
    }

@delegate:ResourceContentHash(-1_701_629_579)
public val Res.string.payroll_fact_tax_relief: StringResource by lazy {
      StringResource("string:payroll_fact_tax_relief", "payroll_fact_tax_relief", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209182, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296734, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190933, 39),
      ))
    }

@delegate:ResourceContentHash(750_421_632)
public val Res.string.payroll_fact_under26: StringResource by lazy {
      StringResource("string:payroll_fact_under26", "payroll_fact_under26", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209222, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296774, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190973, 40),
      ))
    }

@delegate:ResourceContentHash(-242_101_845)
public val Res.string.payroll_fact_voluntary_sickness: StringResource by lazy {
      StringResource("string:payroll_fact_voluntary_sickness", "payroll_fact_voluntary_sickness", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209271, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296827, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191014, 79),
      ))
    }

@delegate:ResourceContentHash(-867_048_819)
public val Res.string.payroll_gross: StringResource by lazy {
      StringResource("string:payroll_gross", "payroll_gross", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209359, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296975, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191094, 29),
      ))
    }

@delegate:ResourceContentHash(2_079_716_829)
public val Res.string.payroll_holiday_pay: StringResource by lazy {
      StringResource("string:payroll_holiday_pay", "payroll_holiday_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209389, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 297013, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191124, 71),
      ))
    }

@delegate:ResourceContentHash(1_696_030_039)
public val Res.string.payroll_holiday_variable: StringResource by lazy {
      StringResource("string:payroll_holiday_variable", "payroll_holiday_variable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209481, 140),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 297117, 196),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191196, 104),
      ))
    }

@delegate:ResourceContentHash(-1_156_957_400)
public val Res.string.payroll_hours: StringResource by lazy {
      StringResource("string:payroll_hours", "payroll_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209622, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 297314, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191301, 65),
      ))
    }

@delegate:ResourceContentHash(1_493_392_031)
public val Res.string.payroll_insured_elsewhere: StringResource by lazy {
      StringResource("string:payroll_insured_elsewhere", "payroll_insured_elsewhere", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209696, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 297432, 193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191367, 93),
      ))
    }

@delegate:ResourceContentHash(-106_355_190)
public val Res.string.payroll_leave_year: StringResource by lazy {
      StringResource("string:payroll_leave_year", "payroll_leave_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209814, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 297626, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191461, 98),
      ))
    }

@delegate:ResourceContentHash(471_106_935)
public val Res.string.payroll_long_service: StringResource by lazy {
      StringResource("string:payroll_long_service", "payroll_long_service", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209905, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 297785, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191560, 120),
      ))
    }

@delegate:ResourceContentHash(1_347_388_290)
public val Res.string.payroll_minimum_top_up: StringResource by lazy {
      StringResource("string:payroll_minimum_top_up", "payroll_minimum_top_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210014, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 297970, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191681, 58),
      ))
    }

@delegate:ResourceContentHash(-817_319_390)
public val Res.string.payroll_missing_rates: StringResource by lazy {
      StringResource("string:payroll_missing_rates", "payroll_missing_rates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210089, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 298081, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191740, 93),
      ))
    }

@delegate:ResourceContentHash(-1_498_840_952)
public val Res.string.payroll_month_items: StringResource by lazy {
      StringResource("string:payroll_month_items", "payroll_month_items", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210167, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 298199, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191834, 95),
      ))
    }

@delegate:ResourceContentHash(-1_442_502_014)
public val Res.string.payroll_net: StringResource by lazy {
      StringResource("string:payroll_net", "payroll_net", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210247, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 298323, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191930, 39),
      ))
    }

@delegate:ResourceContentHash(924_194_081)
public val Res.string.payroll_no_pay_set: StringResource by lazy {
      StringResource("string:payroll_no_pay_set", "payroll_no_pay_set", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210403, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 298575, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192070, 42),
      ))
    }

@delegate:ResourceContentHash(-601_829_821)
public val Res.string.payroll_no_pay_set_hint: StringResource by lazy {
      StringResource("string:payroll_no_pay_set_hint", "payroll_no_pay_set_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210291, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 298379, 195),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191970, 99),
      ))
    }

@delegate:ResourceContentHash(1_325_522_141)
public val Res.string.payroll_over50: StringResource by lazy {
      StringResource("string:payroll_over50", "payroll_over50", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210454, 134),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 298650, 230),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192113, 130),
      ))
    }

@delegate:ResourceContentHash(-596_395_552)
public val Res.string.payroll_overtime_100: StringResource by lazy {
      StringResource("string:payroll_overtime_100", "payroll_overtime_100", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210589, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 298881, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192244, 60),
      ))
    }

@delegate:ResourceContentHash(-872_898_640)
public val Res.string.payroll_overtime_50: StringResource by lazy {
      StringResource("string:payroll_overtime_50", "payroll_overtime_50", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210650, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 298962, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192305, 55),
      ))
    }

@delegate:ResourceContentHash(-1_552_834_929)
public val Res.string.payroll_overtime_pay: StringResource by lazy {
      StringResource("string:payroll_overtime_pay", "payroll_overtime_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210710, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 299038, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192361, 72),
      ))
    }

@delegate:ResourceContentHash(-98_826_162)
public val Res.string.payroll_paid_leave: StringResource by lazy {
      StringResource("string:payroll_paid_leave", "payroll_paid_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210791, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 299139, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192434, 62),
      ))
    }

@delegate:ResourceContentHash(1_632_718_782)
public val Res.string.payroll_plan_vs_actual: StringResource by lazy {
      StringResource("string:payroll_plan_vs_actual", "payroll_plan_vs_actual", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210862, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 299250, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192497, 50),
      ))
    }

@delegate:ResourceContentHash(-1_577_504_739)
public val Res.string.payroll_ppk: StringResource by lazy {
      StringResource("string:payroll_ppk", "payroll_ppk", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 211017, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 299449, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192644, 91),
      ))
    }

@delegate:ResourceContentHash(-1_558_989_113)
public val Res.string.payroll_ppk_reduced: StringResource by lazy {
      StringResource("string:payroll_ppk_reduced", "payroll_ppk_reduced", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 210917, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 299309, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192548, 95),
      ))
    }

@delegate:ResourceContentHash(-2_117_073_492)
public val Res.string.payroll_rate_change: StringResource by lazy {
      StringResource("string:payroll_rate_change", "payroll_rate_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 211105, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 299581, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192736, 95),
      ))
    }

@delegate:ResourceContentHash(1_553_726_961)
public val Res.string.payroll_rate_from: StringResource by lazy {
      StringResource("string:payroll_rate_from", "payroll_rate_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 211229, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 299753, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192832, 45),
      ))
    }

@delegate:ResourceContentHash(-196_510_180)
public val Res.string.payroll_rate_hourly: StringResource by lazy {
      StringResource("string:payroll_rate_hourly", "payroll_rate_hourly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 211275, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 299799, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192878, 43),
      ))
    }

@delegate:ResourceContentHash(-2_058_132_335)
public val Res.string.payroll_rate_monthly: StringResource by lazy {
      StringResource("string:payroll_rate_monthly", "payroll_rate_monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 211327, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 299859, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192922, 44),
      ))
    }

@delegate:ResourceContentHash(693_093_076)
public val Res.string.payroll_refunds: StringResource by lazy {
      StringResource("string:payroll_refunds", "payroll_refunds", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 211380, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 299920, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192967, 43),
      ))
    }

@delegate:ResourceContentHash(3_563_342)
public val Res.string.payroll_row_hours: StringResource by lazy {
      StringResource("string:payroll_row_hours", "payroll_row_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 211428, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 299996, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193011, 33),
      ))
    }

@delegate:ResourceContentHash(-1_567_040_655)
public val Res.string.payroll_salary_reduction: StringResource by lazy {
      StringResource("string:payroll_salary_reduction", "payroll_salary_reduction", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 211466, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 300038, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193045, 88),
      ))
    }

@delegate:ResourceContentHash(-1_405_674_909)
public val Res.string.payroll_settlement_hours: StringResource by lazy {
      StringResource("string:payroll_settlement_hours", "payroll_settlement_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 211555, 176),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 300159, 296),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193134, 160),
      ))
    }

@delegate:ResourceContentHash(-1_863_999_950)
public val Res.string.payroll_shifts_cost: StringResource by lazy {
      StringResource("string:payroll_shifts_cost", "payroll_shifts_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 211732, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 300456, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193295, 63),
      ))
    }

@delegate:ResourceContentHash(1_084_643_667)
public val Res.string.payroll_sick_base: StringResource by lazy {
      StringResource("string:payroll_sick_base", "payroll_sick_base", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 211800, 245),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 300548, 429),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193359, 201),
      ))
    }

@delegate:ResourceContentHash(435_452_170)
public val Res.string.payroll_sick_benefit: StringResource by lazy {
      StringResource("string:payroll_sick_benefit", "payroll_sick_benefit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212046, 112),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 300978, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193561, 104),
      ))
    }

@delegate:ResourceContentHash(-1_431_776_331)
public val Res.string.payroll_sick_pay: StringResource by lazy {
      StringResource("string:payroll_sick_pay", "payroll_sick_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212159, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 301147, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193666, 64),
      ))
    }

@delegate:ResourceContentHash(-1_285_017_862)
public val Res.string.payroll_student: StringResource by lazy {
      StringResource("string:payroll_student", "payroll_student", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212350, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 301442, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193817, 59),
      ))
    }

@delegate:ResourceContentHash(-962_407_827)
public val Res.string.payroll_student_until: StringResource by lazy {
      StringResource("string:payroll_student_until", "payroll_student_until", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212248, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 301304, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193731, 85),
      ))
    }

@delegate:ResourceContentHash(2_035_150_294)
public val Res.string.payroll_sunday_holiday: StringResource by lazy {
      StringResource("string:payroll_sunday_holiday", "payroll_sunday_holiday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212414, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 301534, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193877, 94),
      ))
    }

@delegate:ResourceContentHash(-1_417_771_965)
public val Res.string.payroll_tax_relief: StringResource by lazy {
      StringResource("string:payroll_tax_relief", "payroll_tax_relief", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212509, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 301673, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193972, 66),
      ))
    }

@delegate:ResourceContentHash(-215_557_067)
public val Res.string.payroll_time_off_owed: StringResource by lazy {
      StringResource("string:payroll_time_off_owed", "payroll_time_off_owed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212584, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 301780, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194039, 73),
      ))
    }

@delegate:ResourceContentHash(480_798_000)
public val Res.string.payroll_title: StringResource by lazy {
      StringResource("string:payroll_title", "payroll_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212654, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 301882, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194113, 37),
      ))
    }

@delegate:ResourceContentHash(-1_146_577_553)
public val Res.string.payroll_to_pay: StringResource by lazy {
      StringResource("string:payroll_to_pay", "payroll_to_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212692, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 301952, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194151, 46),
      ))
    }

@delegate:ResourceContentHash(-537_568_099)
public val Res.string.payroll_under26: StringResource by lazy {
      StringResource("string:payroll_under26", "payroll_under26", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212833, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 302153, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194272, 63),
      ))
    }

@delegate:ResourceContentHash(-1_469_807_776)
public val Res.string.payroll_under26_until: StringResource by lazy {
      StringResource("string:payroll_under26_until", "payroll_under26_until", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212743, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 302023, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194198, 73),
      ))
    }

@delegate:ResourceContentHash(-779_066_481)
public val Res.string.payroll_unpaid_reduction: StringResource by lazy {
      StringResource("string:payroll_unpaid_reduction", "payroll_unpaid_reduction", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212905, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 302269, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194336, 68),
      ))
    }

@delegate:ResourceContentHash(-1_860_279_440)
public val Res.string.payroll_until_hint: StringResource by lazy {
      StringResource("string:payroll_until_hint", "payroll_until_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 212994, 206),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 302386, 298),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194405, 202),
      ))
    }

@delegate:ResourceContentHash(-1_256_318_497)
public val Res.string.payroll_vacation_in_salary: StringResource by lazy {
      StringResource("string:payroll_vacation_in_salary", "payroll_vacation_in_salary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 213201, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 302685, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194608, 102),
      ))
    }

@delegate:ResourceContentHash(-242_101_845)
public val Res.string.payroll_voluntary_sickness: StringResource by lazy {
      StringResource("string:payroll_voluntary_sickness", "payroll_voluntary_sickness", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 213304, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 302832, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194711, 74),
      ))
    }

@delegate:ResourceContentHash(1_871_389_171)
public val Res.string.payroll_works_unpaid: StringResource by lazy {
      StringResource("string:payroll_works_unpaid", "payroll_works_unpaid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 213387, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 302975, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194786, 44),
      ))
    }

@delegate:ResourceContentHash(-823_447_289)
public val Res.string.paywall_already_premium: StringResource by lazy {
      StringResource("string:paywall_already_premium", "paywall_already_premium", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 213440, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 303032, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194831, 59),
      ))
    }

@delegate:ResourceContentHash(68_478_998)
public val Res.string.paywall_change_current_plan: StringResource by lazy {
      StringResource("string:paywall_change_current_plan", "paywall_change_current_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 213496, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 303092, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194891, 71),
      ))
    }

@delegate:ResourceContentHash(-511_462_098)
public val Res.string.paywall_change_in_portal: StringResource by lazy {
      StringResource("string:paywall_change_in_portal", "paywall_change_in_portal", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 213568, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 303184, 208),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194963, 120),
      ))
    }

@delegate:ResourceContentHash(-519_858_478)
public val Res.string.paywall_change_now_notice: StringResource by lazy {
      StringResource("string:paywall_change_now_notice", "paywall_change_now_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 213685, 205),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 303393, 345),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195084, 189),
      ))
    }

@delegate:ResourceContentHash(-686_477_887)
public val Res.string.paywall_change_open_store: StringResource by lazy {
      StringResource("string:paywall_change_open_store", "paywall_change_open_store", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 213891, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 303739, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195274, 69),
      ))
    }

@delegate:ResourceContentHash(-2_108_541_116)
public val Res.string.paywall_change_other_store_notice: StringResource by lazy {
      StringResource("string:paywall_change_other_store_notice", "paywall_change_other_store_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 213965, 237),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 303853, 393),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195344, 217),
      ))
    }

@delegate:ResourceContentHash(1_421_610_358)
public val Res.string.paywall_change_plan: StringResource by lazy {
      StringResource("string:paywall_change_plan", "paywall_change_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 214203, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 304247, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195562, 43),
      ))
    }

@delegate:ResourceContentHash(2_127_956_302)
public val Res.string.paywall_change_portal_notice: StringResource by lazy {
      StringResource("string:paywall_change_portal_notice", "paywall_change_portal_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 214247, 272),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 304311, 440),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195606, 252),
      ))
    }

@delegate:ResourceContentHash(1_160_746_634)
public val Res.string.paywall_change_promo_notice: StringResource by lazy {
      StringResource("string:paywall_change_promo_notice", "paywall_change_promo_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 214520, 163),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 304752, 243),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195859, 159),
      ))
    }

@delegate:ResourceContentHash(2_029_983_537)
public val Res.string.paywall_change_renewal_notice: StringResource by lazy {
      StringResource("string:paywall_change_renewal_notice", "paywall_change_renewal_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 214866, 189),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 305270, 285),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196201, 189),
      ))
    }

@delegate:ResourceContentHash(-384_181_693)
public val Res.string.paywall_change_renewal_notice_undated: StringResource by lazy {
      StringResource("string:paywall_change_renewal_notice_undated", "paywall_change_renewal_notice_undated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 214684, 181),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 304996, 273),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196019, 181),
      ))
    }

@delegate:ResourceContentHash(-2_012_168_124)
public val Res.string.paywall_change_scheduled: StringResource by lazy {
      StringResource("string:paywall_change_scheduled", "paywall_change_scheduled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 215056, 112),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 305556, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196391, 100),
      ))
    }

@delegate:ResourceContentHash(720_882_255)
public val Res.string.paywall_choose_period: StringResource by lazy {
      StringResource("string:paywall_choose_period", "paywall_choose_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 215169, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 305725, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196492, 53),
      ))
    }

@delegate:ResourceContentHash(-1_293_162_543)
public val Res.string.paywall_choose_seats: StringResource by lazy {
      StringResource("string:paywall_choose_seats", "paywall_choose_seats", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 215235, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 305807, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196546, 72),
      ))
    }

@delegate:ResourceContentHash(-21_853_904)
public val Res.string.paywall_compare_title: StringResource by lazy {
      StringResource("string:paywall_compare_title", "paywall_compare_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 215304, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 305924, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196619, 61),
      ))
    }

@delegate:ResourceContentHash(2_097_415_441)
public val Res.string.paywall_current_badge: StringResource by lazy {
      StringResource("string:paywall_current_badge", "paywall_current_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 215358, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 306006, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196681, 41),
      ))
    }

@delegate:ResourceContentHash(505_660_046)
public val Res.string.paywall_current_plan_notice: StringResource by lazy {
      StringResource("string:paywall_current_plan_notice", "paywall_current_plan_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 215396, 139),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 306060, 235),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196723, 135),
      ))
    }

@delegate:ResourceContentHash(1_993_687_887)
public val Res.string.paywall_free_trial: StringResource by lazy {
      StringResource("string:paywall_free_trial", "paywall_free_trial", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 215536, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 306296, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196859, 38),
      ))
    }

@delegate:ResourceContentHash(1_594_057_142)
public val Res.string.paywall_go_to_plan: StringResource by lazy {
      StringResource("string:paywall_go_to_plan", "paywall_go_to_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 215583, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 306359, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196898, 74),
      ))
    }

@delegate:ResourceContentHash(596_614_105)
public val Res.string.paywall_grow_freely: StringResource by lazy {
      StringResource("string:paywall_grow_freely", "paywall_grow_freely", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 215650, 151),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 306446, 243),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196973, 143),
      ))
    }

@delegate:ResourceContentHash(1_347_671_138)
public val Res.string.paywall_hide_other_plans: StringResource by lazy {
      StringResource("string:paywall_hide_other_plans", "paywall_hide_other_plans", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 215802, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 306690, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197117, 56),
      ))
    }

@delegate:ResourceContentHash(1_405_762_071)
public val Res.string.paywall_included_money: StringResource by lazy {
      StringResource("string:paywall_included_money", "paywall_included_money", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 215859, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 306771, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197174, 90),
      ))
    }

@delegate:ResourceContentHash(-1_162_638_482)
public val Res.string.paywall_included_scheduling: StringResource by lazy {
      StringResource("string:paywall_included_scheduling", "paywall_included_scheduling", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 215962, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 306942, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197265, 91),
      ))
    }

@delegate:ResourceContentHash(216_592_879)
public val Res.string.paywall_included_team: StringResource by lazy {
      StringResource("string:paywall_included_team", "paywall_included_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 216141, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 307213, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197436, 97),
      ))
    }

@delegate:ResourceContentHash(-2_079_173_678)
public val Res.string.paywall_included_team_free: StringResource by lazy {
      StringResource("string:paywall_included_team_free", "paywall_included_team_free", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 216046, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 307050, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197357, 78),
      ))
    }

@delegate:ResourceContentHash(-1_147_108_172)
public val Res.string.paywall_included_workplaces: StringResource by lazy {
      StringResource("string:paywall_included_workplaces", "paywall_included_workplaces", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 216251, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 307371, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197534, 63),
      ))
    }

@delegate:ResourceContentHash(1_959_219_709)
public val Res.string.paywall_intro_price: StringResource by lazy {
      StringResource("string:paywall_intro_price", "paywall_intro_price", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 216307, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 307471, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197598, 79),
      ))
    }

@delegate:ResourceContentHash(875_337_135)
public val Res.string.paywall_intro_then: StringResource by lazy {
      StringResource("string:paywall_intro_then", "paywall_intro_then", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 216387, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 307587, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197678, 70),
      ))
    }

@delegate:ResourceContentHash(-675_504_292)
public val Res.string.paywall_larger_team: StringResource by lazy {
      StringResource("string:paywall_larger_team", "paywall_larger_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 216631, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 307967, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197910, 59),
      ))
    }

@delegate:ResourceContentHash(1_655_517_732)
public val Res.string.paywall_larger_team_desc: StringResource by lazy {
      StringResource("string:paywall_larger_team_desc", "paywall_larger_team_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 216462, 168),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 307686, 280),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197749, 160),
      ))
    }

@delegate:ResourceContentHash(926_062_105)
public val Res.string.paywall_limit_seats: StringResource by lazy {
      StringResource("string:paywall_limit_seats", "paywall_limit_seats", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 216703, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 308059, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197970, 55),
      ))
    }

@delegate:ResourceContentHash(-1_412_398_167)
public val Res.string.paywall_limit_workplaces: StringResource by lazy {
      StringResource("string:paywall_limit_workplaces", "paywall_limit_workplaces", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 216751, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 308123, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198026, 48),
      ))
    }

@delegate:ResourceContentHash(1_256_327_250)
public val Res.string.paywall_no_offers: StringResource by lazy {
      StringResource("string:paywall_no_offers", "paywall_no_offers", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 216792, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 308176, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198075, 69),
      ))
    }

@delegate:ResourceContentHash(-1_809_771_702)
public val Res.string.paywall_not_configured_desc: StringResource by lazy {
      StringResource("string:paywall_not_configured_desc", "paywall_not_configured_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 216866, 183),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 308278, 223),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198145, 175),
      ))
    }

@delegate:ResourceContentHash(-1_443_956_155)
public val Res.string.paywall_not_configured_title: StringResource by lazy {
      StringResource("string:paywall_not_configured_title", "paywall_not_configured_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217050, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 308502, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198321, 64),
      ))
    }

@delegate:ResourceContentHash(2_125_612_592)
public val Res.string.paywall_not_now: StringResource by lazy {
      StringResource("string:paywall_not_now", "paywall_not_now", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217115, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 308599, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198386, 35),
      ))
    }

@delegate:ResourceContentHash(-854_816_749)
public val Res.string.paywall_offers_error: StringResource by lazy {
      StringResource("string:paywall_offers_error", "paywall_offers_error", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217151, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 308643, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198422, 64),
      ))
    }

@delegate:ResourceContentHash(-1_948_732_340)
public val Res.string.paywall_other_plans: StringResource by lazy {
      StringResource("string:paywall_other_plans", "paywall_other_plans", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217224, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 308748, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198487, 43),
      ))
    }

@delegate:ResourceContentHash(949_327_358)
public val Res.string.paywall_period_lifetime: StringResource by lazy {
      StringResource("string:paywall_period_lifetime", "paywall_period_lifetime", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217268, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 308804, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198531, 55),
      ))
    }

@delegate:ResourceContentHash(2_032_645_452)
public val Res.string.paywall_period_monthly: StringResource by lazy {
      StringResource("string:paywall_period_monthly", "paywall_period_monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217316, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 308872, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198587, 42),
      ))
    }

@delegate:ResourceContentHash(1_145_222_361)
public val Res.string.paywall_period_other: StringResource by lazy {
      StringResource("string:paywall_period_other", "paywall_period_other", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217363, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 308927, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198630, 44),
      ))
    }

@delegate:ResourceContentHash(-2_034_048_552)
public val Res.string.paywall_period_quarterly: StringResource by lazy {
      StringResource("string:paywall_period_quarterly", "paywall_period_quarterly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217408, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 308980, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198675, 52),
      ))
    }

@delegate:ResourceContentHash(1_184_604_122)
public val Res.string.paywall_period_semiannual: StringResource by lazy {
      StringResource("string:paywall_period_semiannual", "paywall_period_semiannual", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217461, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309049, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198728, 53),
      ))
    }

@delegate:ResourceContentHash(812_804_937)
public val Res.string.paywall_period_weekly: StringResource by lazy {
      StringResource("string:paywall_period_weekly", "paywall_period_weekly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217515, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309119, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198782, 37),
      ))
    }

@delegate:ResourceContentHash(1_811_684_580)
public val Res.string.paywall_period_yearly: StringResource by lazy {
      StringResource("string:paywall_period_yearly", "paywall_period_yearly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217561, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309169, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198820, 37),
      ))
    }

@delegate:ResourceContentHash(-2_058_132_335)
public val Res.string.paywall_price_monthly_phrase: StringResource by lazy {
      StringResource("string:paywall_price_monthly_phrase", "paywall_price_monthly_phrase", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217599, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309215, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198858, 52),
      ))
    }

@delegate:ResourceContentHash(1_125_814_335)
public val Res.string.paywall_price_per_month: StringResource by lazy {
      StringResource("string:paywall_price_per_month", "paywall_price_per_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217660, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309284, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198911, 47),
      ))
    }

@delegate:ResourceContentHash(1_653_752_214)
public val Res.string.paywall_price_per_week: StringResource by lazy {
      StringResource("string:paywall_price_per_week", "paywall_price_per_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217712, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309344, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198959, 46),
      ))
    }

@delegate:ResourceContentHash(-1_021_259_868)
public val Res.string.paywall_price_per_year: StringResource by lazy {
      StringResource("string:paywall_price_per_year", "paywall_price_per_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217763, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309403, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199006, 46),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString26Resources(map: MutableMap<String, StringResource>) {
  map.put("payroll_fact_student", Res.string.payroll_fact_student)
  map.put("payroll_fact_tax_relief", Res.string.payroll_fact_tax_relief)
  map.put("payroll_fact_under26", Res.string.payroll_fact_under26)
  map.put("payroll_fact_voluntary_sickness", Res.string.payroll_fact_voluntary_sickness)
  map.put("payroll_gross", Res.string.payroll_gross)
  map.put("payroll_holiday_pay", Res.string.payroll_holiday_pay)
  map.put("payroll_holiday_variable", Res.string.payroll_holiday_variable)
  map.put("payroll_hours", Res.string.payroll_hours)
  map.put("payroll_insured_elsewhere", Res.string.payroll_insured_elsewhere)
  map.put("payroll_leave_year", Res.string.payroll_leave_year)
  map.put("payroll_long_service", Res.string.payroll_long_service)
  map.put("payroll_minimum_top_up", Res.string.payroll_minimum_top_up)
  map.put("payroll_missing_rates", Res.string.payroll_missing_rates)
  map.put("payroll_month_items", Res.string.payroll_month_items)
  map.put("payroll_net", Res.string.payroll_net)
  map.put("payroll_no_pay_set", Res.string.payroll_no_pay_set)
  map.put("payroll_no_pay_set_hint", Res.string.payroll_no_pay_set_hint)
  map.put("payroll_over50", Res.string.payroll_over50)
  map.put("payroll_overtime_100", Res.string.payroll_overtime_100)
  map.put("payroll_overtime_50", Res.string.payroll_overtime_50)
  map.put("payroll_overtime_pay", Res.string.payroll_overtime_pay)
  map.put("payroll_paid_leave", Res.string.payroll_paid_leave)
  map.put("payroll_plan_vs_actual", Res.string.payroll_plan_vs_actual)
  map.put("payroll_ppk", Res.string.payroll_ppk)
  map.put("payroll_ppk_reduced", Res.string.payroll_ppk_reduced)
  map.put("payroll_rate_change", Res.string.payroll_rate_change)
  map.put("payroll_rate_from", Res.string.payroll_rate_from)
  map.put("payroll_rate_hourly", Res.string.payroll_rate_hourly)
  map.put("payroll_rate_monthly", Res.string.payroll_rate_monthly)
  map.put("payroll_refunds", Res.string.payroll_refunds)
  map.put("payroll_row_hours", Res.string.payroll_row_hours)
  map.put("payroll_salary_reduction", Res.string.payroll_salary_reduction)
  map.put("payroll_settlement_hours", Res.string.payroll_settlement_hours)
  map.put("payroll_shifts_cost", Res.string.payroll_shifts_cost)
  map.put("payroll_sick_base", Res.string.payroll_sick_base)
  map.put("payroll_sick_benefit", Res.string.payroll_sick_benefit)
  map.put("payroll_sick_pay", Res.string.payroll_sick_pay)
  map.put("payroll_student", Res.string.payroll_student)
  map.put("payroll_student_until", Res.string.payroll_student_until)
  map.put("payroll_sunday_holiday", Res.string.payroll_sunday_holiday)
  map.put("payroll_tax_relief", Res.string.payroll_tax_relief)
  map.put("payroll_time_off_owed", Res.string.payroll_time_off_owed)
  map.put("payroll_title", Res.string.payroll_title)
  map.put("payroll_to_pay", Res.string.payroll_to_pay)
  map.put("payroll_under26", Res.string.payroll_under26)
  map.put("payroll_under26_until", Res.string.payroll_under26_until)
  map.put("payroll_unpaid_reduction", Res.string.payroll_unpaid_reduction)
  map.put("payroll_until_hint", Res.string.payroll_until_hint)
  map.put("payroll_vacation_in_salary", Res.string.payroll_vacation_in_salary)
  map.put("payroll_voluntary_sickness", Res.string.payroll_voluntary_sickness)
  map.put("payroll_works_unpaid", Res.string.payroll_works_unpaid)
  map.put("paywall_already_premium", Res.string.paywall_already_premium)
  map.put("paywall_change_current_plan", Res.string.paywall_change_current_plan)
  map.put("paywall_change_in_portal", Res.string.paywall_change_in_portal)
  map.put("paywall_change_now_notice", Res.string.paywall_change_now_notice)
  map.put("paywall_change_open_store", Res.string.paywall_change_open_store)
  map.put("paywall_change_other_store_notice", Res.string.paywall_change_other_store_notice)
  map.put("paywall_change_plan", Res.string.paywall_change_plan)
  map.put("paywall_change_portal_notice", Res.string.paywall_change_portal_notice)
  map.put("paywall_change_promo_notice", Res.string.paywall_change_promo_notice)
  map.put("paywall_change_renewal_notice", Res.string.paywall_change_renewal_notice)
  map.put("paywall_change_renewal_notice_undated", Res.string.paywall_change_renewal_notice_undated)
  map.put("paywall_change_scheduled", Res.string.paywall_change_scheduled)
  map.put("paywall_choose_period", Res.string.paywall_choose_period)
  map.put("paywall_choose_seats", Res.string.paywall_choose_seats)
  map.put("paywall_compare_title", Res.string.paywall_compare_title)
  map.put("paywall_current_badge", Res.string.paywall_current_badge)
  map.put("paywall_current_plan_notice", Res.string.paywall_current_plan_notice)
  map.put("paywall_free_trial", Res.string.paywall_free_trial)
  map.put("paywall_go_to_plan", Res.string.paywall_go_to_plan)
  map.put("paywall_grow_freely", Res.string.paywall_grow_freely)
  map.put("paywall_hide_other_plans", Res.string.paywall_hide_other_plans)
  map.put("paywall_included_money", Res.string.paywall_included_money)
  map.put("paywall_included_scheduling", Res.string.paywall_included_scheduling)
  map.put("paywall_included_team", Res.string.paywall_included_team)
  map.put("paywall_included_team_free", Res.string.paywall_included_team_free)
  map.put("paywall_included_workplaces", Res.string.paywall_included_workplaces)
  map.put("paywall_intro_price", Res.string.paywall_intro_price)
  map.put("paywall_intro_then", Res.string.paywall_intro_then)
  map.put("paywall_larger_team", Res.string.paywall_larger_team)
  map.put("paywall_larger_team_desc", Res.string.paywall_larger_team_desc)
  map.put("paywall_limit_seats", Res.string.paywall_limit_seats)
  map.put("paywall_limit_workplaces", Res.string.paywall_limit_workplaces)
  map.put("paywall_no_offers", Res.string.paywall_no_offers)
  map.put("paywall_not_configured_desc", Res.string.paywall_not_configured_desc)
  map.put("paywall_not_configured_title", Res.string.paywall_not_configured_title)
  map.put("paywall_not_now", Res.string.paywall_not_now)
  map.put("paywall_offers_error", Res.string.paywall_offers_error)
  map.put("paywall_other_plans", Res.string.paywall_other_plans)
  map.put("paywall_period_lifetime", Res.string.paywall_period_lifetime)
  map.put("paywall_period_monthly", Res.string.paywall_period_monthly)
  map.put("paywall_period_other", Res.string.paywall_period_other)
  map.put("paywall_period_quarterly", Res.string.paywall_period_quarterly)
  map.put("paywall_period_semiannual", Res.string.paywall_period_semiannual)
  map.put("paywall_period_weekly", Res.string.paywall_period_weekly)
  map.put("paywall_period_yearly", Res.string.paywall_period_yearly)
  map.put("paywall_price_monthly_phrase", Res.string.paywall_price_monthly_phrase)
  map.put("paywall_price_per_month", Res.string.paywall_price_per_month)
  map.put("paywall_price_per_week", Res.string.paywall_price_per_week)
  map.put("paywall_price_per_year", Res.string.paywall_price_per_year)
}
